/* eslint-disable max-lines-per-function */
/* #region Imports */
import React, { Component } from 'react';
import { changeLanguage } from '../../../actions/language';
import { connect } from 'react-redux';
import { numberWithCommas } from '../../../utils/consts/index';
import { validateForm, validation } from '../../../utils/validation';
import { convertEnumValueToTitle } from '../../../utils/utility';
import { withRouter } from '~HOC';
import { injectIntl, FormattedMessage } from 'react-intl';
import Pagination from 'react-js-pagination';
import momentjs from 'moment-jalaali';
import ENUMS from '../../../enums';
//#region  importing the common components
import {
  Input,
  ValidationMessage,
  Select,
  Checkbox,
  Toast,
  Modal,
} from '../../../component';
//#endregion
//#region  importing svg icons
import { CloseIcon } from '~svg';
import {
  employeeAllocationApi,
  moneyUnitApi,
  usersApi,
} from '../../../services/apis';
//#endregion
/* #endregion */
class EmployeeCreditAllocation extends Component {
  initialData = {
    id: null,
    credit: null,
    currencyId: null,
    period: null,
  };
  state = {
    reportModal: false,
    ticketModal: false,
    deleteModal: false,
    Records: 0,
    employeeAllocationStatusId: true,
    employeeId: 0,
    profileId: 0,
    data: { ...this.initialData },
    errors: {},
    employeeInfo: {},
    currencyList: [],
    creditExpensesList: [],
    employeeCreditList: [],
    pageNumber: 1,
    expensesPageNumber: 1,
    itemPerPage: 10,
    totalRecords: 0,
  };
  /* #region APIs */
  /* get Employee Info by Employee Id and Profile Id */
  getEmployeeInfo() {
    try {
      usersApi
        .employeeInfo({
          employeeId: this.state.employeeId,
          profileId: this.state.profileId,
        })
        .then((result) => {
          this.setState({ employeeInfo: result.payload.data[0] }, () =>
            this.getAllEmployeeCredits(),
          );
        });
    } catch (error) {
      console.log(error);
    }
  }
  getCreditExpenses(creditId, expensesPageNumber = 1) {
    try {
      employeeAllocationApi
        .getAllExpansessbyCreditId({
          creditId,
          itemPerPage,
          pageNumber: expensesPageNumber,
        })
        .then((result) => {
          this.setState({
            creditExpensesList: result.payload.data.rows,
            Records: result.payload.totalRecords,
            reportModal: true,
          });
        });
    } catch (error) {
      console.log(error);
    }
  }
  /* Get All Employee by ProfileId with paging */
  getAllEmployeeCredits = (pageNumber = 1) => {
    try {
      const { itemPerPage, employeeInfo } = this.state;

      employeeAllocationApi
        .getAllEmployeeCreditByProfileId({
          itemPerPage,
          pageNumber,
          profileId: employeeInfo.profileId,
        })
        .then((result) => {
          this.setState({
            employeeCreditList: result.payload.data.rows,
            totalRecords: result.payload.totalRecords,
          });
        });
    } catch (error) {
      console.log(error);
    }
  };
  /* Delete employee by id */
  deleteEmployeeCredit = () => {
    try {
      let { id } = this.state.employeeCreditList[this.state.deletingIndex];
      employeeAllocationApi.deleteEmployee({ id }).then((result) => {
        this.setState(
          {
            deletingIndex: null,
            data: { ...this.initialData },
            employeeAllocationStatusId: true,
          },
          () => {
            if (result.status === 200) {
              this.setState({
                showAlert: true,
                alertMessage: 'department.departmentdelete',
                alertType: 'success',
              });
            } else
              this.setState({
                showAlert: true,
                alertMessage: 'profile.errordelete',
                alertType: 'danger',
              });
            this.getAllEmployeeCredits();
          },
        );
      });
    } catch (error) {
      console.log(error);
    }
  };
  /* Get employee credit information by id and set all data and set scroll to top of page */
  getCreditINfo(creditId) {
    window.scrollTo(0, 0);

    let result = this.state.employeeCreditList.filter((item) => {
      return item.id === creditId;
    })[0];
    let data = {};
    data.id = result.id;
    data.currencyId = result.currencyId;
    data.credit = Number(result.amount).toFixed(0).toString();
    data.period = result.period;
    this.setState({
      data,
      selectedCredit: result.id,
      employeeAllocationStatusId:
        result.employeeAllocationStatusId === 1 ? true : false,
    });
    setTimeout(() => {
      const errors = this.validate();
      this.setState({ errors: errors || {} }, () => {});
    }, 300);
  }

  /* Get All Currencies */
  getCurrencies = () => {
    try {
      moneyUnitApi
        .getAll()
        .then((currecyLst) => {
          if (currecyLst.status === 200)
            this.setState({ currencyList: currecyLst.payload.data });
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  }; /* Add or Update employee Allocation */
  validate = () => {
    const { error, result } = validateForm({
      credit: validation.number(this.state.data.credit).required().errors,
      period: validation.number(this.state.data.period).required().errors,
      currencyId: validation.text(this.state.data.currencyId).required().errors,
    });
    this.setState({ error });
    return result;
  };
  doSubmit = () => {
    const res = this.validate();
    let params = {
      profileId: this.state.employeeInfo.profileId,
      amount: parseFloat(credit),
      currencyId: currencyId,
      period: parseInt(period),
      employeeAllocationStatusId: this.state.employeeAllocationStatusId ? 1 : 2,
      expireDate: date.toISOString().split('T')[0],
      id: id,
    };
    if (res) {
      const { id, period } = this.state.data;
      var date = new Date();
      date.setDate(date.getDate() + parseInt(period));
      let apiName =
        id > 0
          ? employeeAllocationApi.update({ data: params })
          : employeeAllocationApi.insert({ data: params });

      apiName()
        .then((result) => {
          //this.props.returnResult();
          if (result.status === 200) {
            this.setState({
              data: { ...this.initialData },
              selectedCredit: '0',
              employeeAllocationStatusId: true,
              showAlert: true,
              alertMessage: 'profilecredit.creditadd',
              alertType: 'success',
            });

            this.getAllEmployeeCredits(this.state.pageNumber);
          }
        })
        .catch((error) => {
          if (
            error.status === 500 &&
            error.errMessage ===
              'There is already an active allocation for this profile'
          ) {
            this.setState({
              alertMessage: 'profilecredit.creditadderror',
              alertType: 'danger',
              showAlert: true,
            });
          } else if (
            error.status === 500 &&
            error.errMessage ===
              'This profile is not eligible for an allocation'
          )
            this.setState({
              alertMessage: 'profilecredit.noteligibleprofile',
              alertType: 'danger',
              showAlert: true,
            });
        });
    }
  };
  /* #endregion */

  /* Set validations for fields */
  // schema = {
  //   id: this.validationTypes.optional,
  //   credit: this.validationTypes.requiredNumberWithComma,
  //   currencyId: this.validationTypes.required,
  //   period: this.validationTypes.requiredNumberMoreThanZero,
  // };
  /* #endregion */
  /* #region life style component */
  componentDidMount() {
    const parsedQueryStr = Object.fromEntries(this.props?.location?.search);
    let employeeId, profileId;

    if (
      this.props.location.pathname === '/profile/employee-credit-allocation' &&
      parsedQueryStr &&
      parsedQueryStr.id
    ) {
      employeeId = parsedQueryStr.id;
      profileId = parsedQueryStr.profileId;
    } else {
      employeeId = this.props.employeeId;
      profileId = this.props.profileId;
    }
    this.setState({ employeeId, profileId }, () => {
      this.getEmployeeInfo();
      this.getCurrencies();
      //console.log(" employeeId, profileId ", employeeId, profileId);
    });
  }
  /* #endregion */

  /* region Functions */
  //reload data and change page number to 1
  reloadData = () => {
    this.setState(
      { pageNumber: 1, selectedCredit: '0', data: { ...this.initialData } },
      () => this.getEmployeeInfo(),
    );
  };
  /* Change Page number For expenses report */
  pageExpensesChange = (expensesPageNumber) => {
    this.setState({ expensesPageNumber });
    this.getCreditExpenses(expensesPageNumber);
  };
  /* Change Page number */
  pageChange = (pageNumber) => {
    this.setState({ pageNumber });
    this.getAllEmployeeCredits(pageNumber);
  };
  /* click delete icon */
  onDeleteClick = (indx) => {
    this.setState({ deletingIndex: indx, description: '' });
  };
  getStringDate = (date) => {
    let dd = new Date(date);
    return `${this.addZero(dd.getFullYear())}-${this.addZero(
      dd.getMonth() + 1,
    )}-${this.addZero(dd.getDate())}`;
  };
  addZero = (number) => {
    if (number.toString().length === 1) return `0${number}`;
    else return number;
  };
  returnShamsiDate = () => {
    let { basicInfo } = this.state.employeeInfo;
    if (basicInfo && basicInfo.year) {
      let date = `${basicInfo.year}-${basicInfo.month}-${basicInfo.day}`;
      return this.getStringDate(
        momentjs(date, 'YYYY-MM-DD').format('jYYYY-jMM-jDD'),
      );
    }
  };
  //setstate chackbox value
  isDefaultChecked = (event) => {
    this.setState({ employeeAllocationStatusId: event.target.checked });
  };

  /* #endregion */
  /* render employee information */
  renderEmployeeInfo = () => {
    if (this.state.employeeInfo)
      return (
        <div className="d-flex flex-column col-12 mt-2 p-md-2 p-0">
          <div className="col d-sm-flex flex-md-row flex-column p-0 px-md-4">
            {/* <div className="text-start p-0 col-1">
              {this.renderAvatar(
                this.state.employeeInfo.basicInfo &&
                  this.state.employeeInfo.basicInfo.avatar
              )}
            </div> */}
            <div className="col-4 p-0 d-flex justify-content-start align-items-center flex-column flex-md-row">
              <div className="p-md-1 text-uppercase font-small text-third font-weight-bold">
                <FormattedMessage id="profile.fullname" />:
              </div>
              <div className="pl-1 d-flex p-0 text-white">
                {`${this.state.employeeInfo.firstName} ${this.state.employeeInfo.lastName}`}
              </div>
            </div>
            <div className="col-4 p-0 d-flex flex-wrap flex-column flex-md-row align-items-center">
              <div className="p-md-1 text-uppercase font-small text-third  font-weight-bold">
                <FormattedMessage id="profile.companyname" />:
              </div>
              <div className="p-md-1">
                {this.state.employeeInfo.businessDisplayName &&
                  this.state.employeeInfo.businessDisplayName[
                    this.props.language.name
                  ]}
              </div>
            </div>
            <div className="col-4 p-0 d-flex flex-wrap align-items-center flex-column flex-md-row">
              <div className="p-md-1 text-uppercase font-small text-third font-weight-bold">
                <FormattedMessage id="profile.username" />:
              </div>
              <div className="p-md-1">{this.state.employeeInfo.userName}</div>
            </div>
          </div>
          <div className="col mt-3 d-sm-flex flex-md-row flex-column p-0 px-md-4">
            <div className="col-4 p-0 d-flex flex-wrap flex-column flex-md-row align-items-center">
              <div className="p-md-1 text-uppercase font-small text-third align-self-start font-weight-bold">
                <FormattedMessage id="profile.email" />:
              </div>
              <div className="p-md-1">{this.state.employeeInfo.email}</div>
            </div>
            <div className="col-4 p-0 d-flex flex-wrap align-items-center flex-column flex-md-row">
              <div className="p-md-1 text-uppercase font-small text-third align-self-start font-weight-bold">
                <FormattedMessage id="profile.mobile" />:
              </div>
              <div className="p-md-1" style={{ direction: 'ltr' }}>
                {this.state.employeeInfo.basicInfo &&
                  this.state.employeeInfo.basicInfo.mobile}
              </div>
            </div>
            <div className="col-4 p-0 d-flex flex-wrap align-items-center flex-column flex-md-row">
              <div className="p-md-1 text-uppercase font-small text-third align-self-start font-weight-bold">
                <FormattedMessage id="profile.birthdate" />:
              </div>
              <div className="p-md-1" style={{ direction: 'ltr' }}>
                {this.state.employeeInfo.basicInfo &&
                this.state.employeeInfo.basicInfo.year
                  ? this.props.language.direction === 'ltr'
                    ? this
                        .getStringDate(`${this.state.employeeInfo.basicInfo.year}-
                  ${this.state.employeeInfo.basicInfo.month}-
                  ${this.state.employeeInfo.basicInfo.day}`)
                    : this.returnShamsiDate()
                  : '---'}
              </div>
            </div>
          </div>

          <div className="col mt-3 d-sm-flex flex-md-row flex-column p-0 px-md-4">
            <div className="col-4 p-0 d-flex flex-wrap align-items-center flex-column flex-md-row">
              <div className="p-md-1 text-uppercase font-small text-third align-self-start font-weight-bold">
                <FormattedMessage id="profile.nationalcode" />:
              </div>
              <div className="p-md-1">
                {this.state.employeeInfo.basicInfo &&
                this.state.employeeInfo.basicInfo.nationalCode
                  ? this.state.employeeInfo.basicInfo.nationalCode
                  : '---'}
              </div>
            </div>
            <div className="col-4 p-0 d-flex flex-wrap align-items-center flex-column flex-md-row">
              <div className="p-md-1 text-uppercase font-small text-third align-self-start font-weight-bold">
                <FormattedMessage id="profile.gender" />:
              </div>
              <div className="p-md-1">
                {this.state.employeeInfo.basicInfo &&
                this.state.employeeInfo.basicInfo.gender
                  ? convertEnumValueToTitle(
                      ENUMS.GENDER_TYPES.list,
                      this.state.employeeInfo.basicInfo.gender,
                      this.props.language.name,
                      'en',
                    )
                  : '---'}
              </div>
            </div>
            <div className="col-4 p-0 d-flex flex-wrap align-items-center flex-column flex-md-row">
              <div className="p-md-1 text-uppercase font-small text-third align-self-start font-weight-bold">
                <FormattedMessage id="profile.role" />:
              </div>
              <div className="p-md-1">
                {this.state.employeeInfo.roleName &&
                  this.state.employeeInfo.roleName[this.props.language.name]}
              </div>
            </div>
          </div>
          {/* <div className="col mt-5 d-sm-flex flex-md-row flex-column p-0 px-md-3">
            <div className="col-6 py-2 py-md-0 d-flex p-md-0 flex-wrap align-items-center flex-column flex-md-row">
              <div className="p-md-1 text-uppercase font-small text-third align-self-start font-weight-bold">
                <FormattedMessage id="profile.department" />:
              </div>
              <div className="pl-1 d-flex p-0  font-weight-bold text-white basic-info-font-size align-self-start">
                {this.state.employeeInfo.departmentName}
              </div>
            </div>
          </div> */}
        </div>
      );
  };
  /* Render form */
  renderForm = () => {
    return (
      <form
        id="employee-credit-form"
        name="employee-credit-form"
        onSubmit={this.handleSubmit}
        className="col"
      >
        <div className="col d-flex p-0 mt-4">
          <div className="col-6 px-1">
            <Input
              name={'credit'}
              value={this.state.data.credit}
              label={this.props.intl.formatMessage({
                id: 'profilecredit.creditamountceiling',
              })}
              onChange={(event) => {
                this.setState({
                  error: {
                    ...this.state.error,
                    credit: validation.number(event.target.value).required()
                      .errors,
                  },
                  data: { ...this.state.data, credit: event.target.value },
                });
              }}
              // error={errors[name]}
              className={''}
              outSideLabel={true}
              outSideLabelClass={'text-gray'}
              outSideLabelPosition={'top'}
              language={this.props.language}
            />
            <ValidationMessage errors={this.state.error?.credit} />
          </div>
          <div className="col-6 px-1">
            <Input
              tabIndex={''}
              type={'text'}
              name={'period'}
              value={this.state.data.period}
              label={this.props.intl.formatMessage({
                id: 'profilecredit.duration',
              })}
              onChange={(event) => {
                this.setState({
                  error: {
                    ...this.state.error,
                    period: validation.number(event.target.value).required()
                      .errors,
                  },
                  data: { ...this.state.data, period: event.target.value },
                });
              }}
              // error={errors[name]}
              className={''}
              outSideLabel={true}
              outSideLabelClass={'text-gray'}
              outSideLabelPosition={'top'}
              language={this.props.language}
            />
            <ValidationMessage errors={this.state.error?.period} />
          </div>
        </div>
        <div className="col d-flex p-0">
          <div className="col-6 px-1">
            {this.state.currencyList.length && (
              <Select
                name={'currencyId'}
                label={'profile.currency'}
                value={this.state.data.currencyId}
                options={{
                  data: this.state.currencyList,
                  value: '_id',
                  label: `moneyUnit`,
                }}
                onChange={(e) => {
                  this.setState({
                    error: {
                      ...this.state.error,
                      currencyId: validation.text(e.target.value).required()
                        .errors,
                    },
                    data: { ...this.state.data, currencyId: e.target.value },
                  });
                }}
                // error={errors[name]}
              />
            )}
            <ValidationMessage errors={this.state.error?.currencyId} />
          </div>
          <div className="col d-flex align-items-center flex-row px-1">
            <Checkbox
              id="employeeAllocationStatusId"
              checked={this.state.employeeAllocationStatusId}
              value={this.state.employeeAllocationStatusId}
              name="employeeAllocationStatusId"
              inputClassName="font-smaller font-weight-bold "
              parentInputClassName="font-smaller font-weight-bold"
              onChange={(event) => {
                this.isDefaultChecked(event);
              }}
            />
            &nbsp;&nbsp;
            <label className="d-flex flex-wrap pt-1 ">
              <span className="font-small text-white">
                <FormattedMessage id="profilecredit.active" />
              </span>
            </label>
          </div>
        </div>
        <div className="my-3 w-100 text-uppercase d-flex align-items-center justify-content-center">
          <div className="d-flex p-0 col-6 align-items-center justify-content-end">
            <button
              id="employee-credit-reload"
              name="employee-credit-reload"
              tabIndex={15}
              type="button"
              onClick={() => {
                this.reloadData();
              }}
              className="text-white font-weight-bold btn btn-height-static text-white w-50 btn-secondary cursor-pointer"
            >
              <FormattedMessage id="profile.reload" />
            </button>
          </div>
          <div className=" d-flex p-0 col-6 justify-content-start px-2">
            <button
              id="employee-credit-submit"
              name="employee-credit-submit"
              type="submit"
              onSubmit={this.doSubmit}
              className="text-white font-weight-bold btn btn-height-static text-white w-50 btn-secondary cursor-pointer"
            >
              <FormattedMessage id="profilecredit.assigncredit" />
            </button>
          </div>
        </div>
      </form>
    );
  };

  /* render employee avatar */
  renderAvatar = (value) => {
    return (
      <img
        className="col-7 p-0"
        src={require(`../../../content/images/avatars/${
          value && value.includes('.png') ? value : '1.png'
        }`)}
        alt="avatar"
      />
    );
  };
  /* Render table for showing employee Credits */
  showEmployeeCreditList = () => {
    if (this.state.employeeCreditList.length > 0) {
      return (
        <div className="col-12 mt-4">
          <table className="table table-dark table-striped">
            <thead className="text-center">
              <tr className="">
                <th scope="col">
                  <FormattedMessage id="profile.number" />
                </th>
                <th scope="col">
                  <FormattedMessage id="profilecredit.creditamount" />
                </th>
                <th scope="col">
                  <FormattedMessage id="profilecredit.assigndate" />
                </th>
                <th scope="col">
                  <FormattedMessage id="profilecredit.expensesamount" />
                </th>
                <th scope="col">
                  <FormattedMessage id="profilecredit.remaincreditamount" />
                </th>
                <th scope="col">
                  <FormattedMessage id="profilecredit.creditstatus" />
                </th>
                <th scope="col" />
                <th scope="col" />
                <th scope="col" />
              </tr>
            </thead>
            {this.renderTableBody()}
          </table>

          <div className="d-flex justify-content-center col-12">
            {this.renderPaging()}
          </div>
        </div>
      );
    } else return null;
  };
  //Render Report modal to show expenses
  renderReportModal = () => {
    return (
      <Modal
        title={
          <h5
            className={`${
              this.props.language.direction == 'ltr'
                ? ''
                : 'd-flex justify-content-center py-3 col-11'
            }`}
          >
            <FormattedMessage id="profilecredit.expensesreport" />
          </h5>
        }
        onClose={() => this.setState({ reportModal: false })}
        isOpen={this.state.reportModal}
      >
        {this.state.creditExpensesList.length && this.renderExpensesTable()}
      </Modal>
    );
    // return (
    //   <div className="modal-dialog modal-lg" role="document">
    //     <div className="modal-content col-12 p-0">
    //       <div
    //         className={`${
    //           this.props.language.direction == "ltr"
    //             ? ""
    //             : "justify-content-center"
    //         } border-bottom text-primary`}
    //       >
    //         <button
    //           type="button"
    //           className="close p-2"
    //           data-dismiss="modal"
    //           aria-label="Close"
    //         >
    //           <span aria-hidden="true">&times;</span>
    //         </button>
    //         <h5
    //           className={`${
    //             this.props.language.direction == "ltr"
    //               ? ""
    //               : "d-flex justify-content-center py-3 col-11"
    //           }`}
    //         >
    //           <FormattedMessage id="profilecredit.expensesreport" />
    //         </h5>
    //       </div>
    //       {this.state.creditExpensesList.length && this.renderExpensesTable()}
    //     </div>
    //   </div>
    // );
  };
  //render table to show credit expenses
  renderExpensesTable() {
    if (this.state.creditExpensesList.length > 0)
      return (
        <div className="">
          <table className="m-0 table">
            <thead className="text-center bg-primary text-white">
              <tr className="font-smaller">
                <th scope="col">
                  <FormattedMessage id="profile.number" />
                </th>
                <th scope="col">
                  <FormattedMessage id="booking.flightno" />
                </th>
                <th scope="col">
                  <FormattedMessage id="profilecredit.expensesamount" />
                </th>
                <th scope="col">
                  <FormattedMessage id="booking.paymentstatus" />
                </th>
                {/* <th scope="col">
                  <FormattedMessage id="booking.buyer" />
                </th> */}
                <th scope="col">
                  <FormattedMessage id="booking.orderdate" />
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.creditExpensesList.map((expense, index) => (
                <tr key={expense.id}>
                  <th scope="row" className="text-center">
                    {(this.state.expensesPageNumber - 1) *
                      this.state.itemPerPage +
                      (index + 1)}
                  </th>
                  <td className="text-center">{expense.booking.invoiceNo}</td>
                  <td className="text-center">{`${expense.amount} ${expense.currency.moneyUnit}`}</td>
                  <td className="text-center">
                    {expense.booking.status.name[this.props.language.name]}
                  </td>
                  {/* <td className="text-center">
                    {expense.roleName &&
                      expense.roleName[0].name[this.props.language.name]}
                  </td> */}
                  <td className="text-center">
                    {this.props.language.direction === 'ltr'
                      ? `${
                          expense.booking.orderDate.split('T')[0]
                        } ${expense.booking.orderDate
                          .split('T')[1]
                          .substring(0, 5)}`
                      : momentjs(
                          expense.booking.orderDate.split('T')[0],
                          'YYYY-M-D',
                        ).format('jYYYY-jMM-jDD')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="d-flex justify-content-center col-12">
            {this.renderExpensesPaging()}
          </div>
        </div>
      );
  }

  //Render Delete modal
  renderDeleteModal = () => {
    return (
      <Modal
        title={
          <h5
            className={`${
              this.props.language.direction == 'ltr'
                ? ''
                : 'd-flex justify-content-center col-11'
            }`}
          >
            <FormattedMessage id="profilecredit.deletecredit" />
          </h5>
        }
        isOpen={this.state.deleteModal}
        onClose={() => this.setState({ deleteModal: false })}
      >
        {this.state.employeeCreditList[this.state.deletingIndex] && (
          <div
            className={`${
              this.props.language.direction == 'ltr'
                ? 'modal-body'
                : 'p-2 text-right'
            }`}
          >
            <FormattedMessage id="profilecredit.deleteconfirmation" />
          </div>
        )}
        <div className="modal-footer">
          <button
            name={`cancel-employeeCredit`}
            id={`cancel-employeeCredit`}
            onClick={() => this.setState({ deleteModal: false })}
            type="button"
            className="btn btn-light mx-2"
            data-dismiss="modal"
          >
            <FormattedMessage id="profile.cancel" />
          </button>
          <button
            name={`delete-employeeCredit`}
            id={`delete-employeeCredit`}
            type="button"
            className="btn btn-danger"
            data-dismiss="modal"
            onClick={this.deleteEmployeeCredit}
          >
            <FormattedMessage id="profile.delete" />
          </button>
        </div>
      </Modal>
    );
    // return (
    // 	<div className="modal-dialog" role="document">
    // 		<div className="modal-content">
    // 			<div
    // 				className={`${
    // 					this.props.language.direction == "ltr"
    // 						? ""
    // 						: "justify-content-center"
    // 				} border-bottom p-3 text-primary`}
    // 			>
    // 				<button
    // 					type="button"
    // 					className="close"
    // 					data-dismiss="modal"
    // 					aria-label="Close"
    // 				>
    // 					<span aria-hidden="true">&times;</span>
    // 				</button>
    // 				<h5
    // 					className={`${
    // 						this.props.language.direction == "ltr"
    // 							? ""
    // 							: "d-flex justify-content-center col-11"
    // 					}`}
    // 				>
    // 					<FormattedMessage id="profilecredit.deletecredit" />
    // 				</h5>
    // 			</div>
    // 			{this.state.employeeCreditList[this.state.deletingIndex] && (
    // 				<div
    // 					className={`${
    // 						this.props.language.direction == "ltr"
    // 							? "modal-body"
    // 							: "p-2 text-right"
    // 					}`}
    // 				>
    // 					<FormattedMessage id="profilecredit.deleteconfirmation" />
    // 				</div>
    // 			)}
    // 			<div className="modal-footer">
    // 				<button
    // 					type="button"
    // 					className="btn btn-light mx-2"
    // 					data-dismiss="modal"
    // 				>
    // 					<FormattedMessage id="profile.cancel" />
    // 				</button>
    // 				<button
    // 					type="button"
    // 					className="btn btn-danger"
    // 					data-dismiss="modal"
    // 					onClick={this.deleteEmployeeCredit}
    // 				>
    // 					<FormattedMessage id="profile.delete" />
    // 				</button>
    // 			</div>
    // 		</div>
    // 	</div>
    // );
  };
  /* Render paging For Expenses Report*/
  renderExpensesPaging = () => {
    return (
      <Pagination
        pageRangeDisplayed={5}
        linkClass="page-link"
        itemClass="page-item"
        innerClass="pagination py-4 directionInitial"
        activeClass="active"
        activePage={this.state.expensesPageNumber}
        itemsCountPerPage={this.state.itemPerPage}
        totalItemsCount={this.state.Records}
        onChange={(fun) => this.pageExpensesChange(fun)}
      />
    );
  };
  /* Render paging */
  renderPaging = () => {
    return (
      <Pagination
        pageRangeDisplayed={5}
        linkClass="page-link"
        itemClass="page-item"
        innerClass="pagination py-4 directionInitial"
        activeClass="active"
        activePage={this.state.pageNumber}
        itemsCountPerPage={this.state.itemPerPage}
        totalItemsCount={this.state.totalRecords}
        onChange={(fun) => this.pageChange(fun)}
      />
    );
  };
  /* Render table body */
  renderTableBody = () => {
    return (
      <tbody>
        {this.state.employeeCreditList.map((empCredit, index) => (
          <tr
            // onClick={() => {
            //   this.setScroll(emp.userId, this.state.profileId);
            // }}
            className={`${
              this.state.selectedCredit === empCredit.id
                ? 'bg-gray text-dark font-small'
                : 'text-white font-small'
            }`}
            key={index}
          >
            <th scope="row" className="text-center">
              {(this.state.pageNumber - 1) * this.state.itemPerPage +
                (index + 1)}
            </th>
            <td className="text-center">{`${numberWithCommas(
              Number(empCredit.amount).toFixed(0),
            )} ${empCredit.currency.moneyUnit}`}</td>
            <td className="text-center">
              {empCredit.createdAt && this.props.language.direction === 'ltr'
                ? new Date(empCredit.createdAt).toISOString().split('T')[0]
                : `${momentjs(empCredit.createdAt, 'YYYY-M-D').format(
                    'jYYYY-jMM-jDD',
                  )} `}
            </td>
            <td className="text-center">{`${numberWithCommas(
              empCredit.amount - empCredit.remainAmount,
            )} ${empCredit.currency.moneyUnit}`}</td>
            <td className="text-center">{`${numberWithCommas(
              empCredit.remainAmount,
            )} ${empCredit.currency.moneyUnit}`}</td>
            <td className="text-center">
              {
                empCredit.employeeAllocationStatus.name[
                  this.props.language.name
                ]
              }
            </td>
            <td className="text-center">
              {empCredit.employeeAllocationStatusId === 1 && (
                <div
                  className="d-flex w-100 btn-light-primary text-center cursor-pointer rounded
                  btn-lg m-0 btn-primary-outline justify-content-center align-items-center 
                  text-decoration-none  m-1 m-xl-0"
                  onClick={() => this.getCreditINfo(empCredit.id)}
                >
                  <FormattedMessage id="profile.change" />
                </div>
              )}
            </td>
            <td className="text-center">
              {empCredit.hasExpenses === true && (
                <div
                  className="d-flex w-100 btn-light-primary text-center cursor-pointer rounded 
                  text-decoration-none  btn-lg m-0 btn-primary-outline justify-content-center 
                  align-items-center m-1 m-xl-0"
                  onClick={() => this.getCreditExpenses(empCredit.id)}
                >
                  <FormattedMessage id="profilecredit.expensesreport" />
                </div>
              )}
            </td>
            <td className="py-2 text-center">
              {empCredit.hasExpenses === false && (
                <span onClick={() => this.onDeleteClick(index)}>
                  <CloseIcon />
                </span>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    );
  };
  /* Main render */
  render() {
    const { showModal = false } = this.props;
    return (
      <div style={{ minHeight: !showModal ? '100vh' : '' }}>
        {!showModal && (
          <div
            className="d-flex flex-column text-white align-items-center"
            style={{
              backgroundColor: '#562D59',
              height: '146px',
            }}
          >
            {this.renderEmployeeInfo()}
          </div>
        )}
        <div
          className="w-100 p-3 edit-business-profile-main-div"
          style={{ minHeight: !showModal ? '100vh' : '' }}
        >
          {!showModal && (
            <div className="w-100 d-flex justify-content-center align-items-center py-3 ">
              <span className="text-white font-huge">
                <FormattedMessage id="profilecredit.employeecreditmanagement" />
              </span>
            </div>
          )}
          {this.renderForm()}
          {!this.props.showModal && this.showEmployeeCreditList()}
          <div
            className=" fade"
            id="deleteModal"
            onClick={() => this.setState({ deleteModal: true })}
          >
            {this.renderDeleteModal()}
          </div>
          <div
            className=" fade"
            id="reportModal"
            onClick={() => this.setState({ reportModal: true })}
          >
            {this.renderReportModal()}
          </div>
        </div>
        <Toast
          isOpen={showAlert}
          onClose={() => this.setState({ showAlert: false })}
          state={alertType}
          position="bottom"
          message={intl.formatMessage({
            id: alertMessage,
          })}
          direction={direction}
        />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    language: state.language,
  };
}
export default injectIntl(
  connect(mapStateToProps, { changeLanguage })(
    withRouter(EmployeeCreditAllocation),
  ),
);
